import { render, staticRenderFns } from "./BarOrGraph.vue?vue&type=template&id=18a37c9b&scoped=true"
import script from "./BarOrGraph.vue?vue&type=script&lang=js"
export * from "./BarOrGraph.vue?vue&type=script&lang=js"
import style0 from "./BarOrGraph.vue?vue&type=style&index=0&id=18a37c9b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a37c9b",
  null
  
)

export default component.exports